/* GLOBAL COMPUTE STYLES */
import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
import { FORM_MAX_WIDTH, PAGE_CONTENT_MAX_WIDTH } from 'styles/constants';
export const computePageStyles = {
  contentWrapper: "odules__Compute__styles_ts-contentWrapper-caob8g0",
  content: "odules__Compute__styles_ts-content-cxyktb5",
  createInstanceTable: "odules__Compute__styles_ts-createInstanceTable-c1o589d5",
  createForm: "odules__Compute__styles_ts-createForm-c10l4e5c",
  deployForm: "odules__Compute__styles_ts-deployForm-dbxk9zk"
};
export const computeDashboardStyles = {
  cardsContainer: "odules__Compute__styles_ts-cardsContainer-c53pibm"
};
export const computeViewStyles = {
  content: "odules__Compute__styles_ts-content-c14twfgv",
  sectionHeader: "odules__Compute__styles_ts-sectionHeader-spek65h"
};
export const computeFormStyles = {
  limitInputWidth: "odules__Compute__styles_ts-limitInputWidth-l1anx59p",
  leftPaddedField: "odules__Compute__styles_ts-leftPaddedField-lrmo79f",
  input: "odules__Compute__styles_ts-input-ig90aev",
  checkbox: "odules__Compute__styles_ts-checkbox-c14r7wbi",
  switch: "odules__Compute__styles_ts-switch-srlu9dz",
  checkboxLabel: "odules__Compute__styles_ts-checkboxLabel-cqs0xtl",
  uniqueId: "odules__Compute__styles_ts-uniqueId-u1cw6wlf",
  hint: "odules__Compute__styles_ts-hint-h1ah0a1e",
  sectionDivider: "odules__Compute__styles_ts-sectionDivider-s1nbwged",
  compatibilityStatus: "odules__Compute__styles_ts-compatibilityStatus-c1j66b7c",
  internalOnly: "odules__Compute__styles_ts-internalOnly-iakw9t0",
  internalOnlyText: "odules__Compute__styles_ts-internalOnlyText-ie2z5j9",
  internalOnlyDescription: "odules__Compute__styles_ts-internalOnlyDescription-ian1w9q",
  formContent: "odules__Compute__styles_ts-formContent-f1ma17cs",
  formContentLoading: "odules__Compute__styles_ts-formContentLoading-f1x1d770",
  visibilityRadio: "odules__Compute__styles_ts-visibilityRadio-v1pb91gq",
  visibilityBadge: "odules__Compute__styles_ts-visibilityBadge-vp5qtdp",
  visibilityBadgeInfo: "odules__Compute__styles_ts-visibilityBadgeInfo-v153flhr",
  visibilityRadioDisabled: "odules__Compute__styles_ts-visibilityRadioDisabled-v9fkf27"
};
export const computeActionStyles = {
  actionListButton: "odules__Compute__styles_ts-actionListButton-a1lojums",
  deleteModalLayout: "odules__Compute__styles_ts-deleteModalLayout-d17mec35",
  deleteModalIds: "odules__Compute__styles_ts-deleteModalIds-d1mg5ic8",
  deleteModalConfirm: "odules__Compute__styles_ts-deleteModalConfirm-d1un4gfn"
};
export const computeTableStyles = {
  table: "odules__Compute__styles_ts-table-t1o2pjta",
  tableControlsWrapper: "odules__Compute__styles_ts-tableControlsWrapper-tatao9m",
  tableControlsLeft: "odules__Compute__styles_ts-tableControlsLeft-tc2ob0s",
  tableControlsRight: "odules__Compute__styles_ts-tableControlsRight-th6obpu",
  tableFilters: "odules__Compute__styles_ts-tableFilters-tsyt3o9",
  searchInput: "odules__Compute__styles_ts-searchInput-s1phq4fe"
};
export const computeProviderStyles = {
  optionLayout: "odules__Compute__styles_ts-optionLayout-o4k1sg9",
  optionIcon: "odules__Compute__styles_ts-optionIcon-o1s9r9ti",
  optionText: "odules__Compute__styles_ts-optionText-o6inm2s"
};
export const computeInfoCardStyles = {
  wrapper: "odules__Compute__styles_ts-wrapper-w18bnjbi",
  title: "odules__Compute__styles_ts-title-t6aje4o",
  fullWidth: "odules__Compute__styles_ts-fullWidth-f184ttuk",
  tightLayout: "odules__Compute__styles_ts-tightLayout-t1ysoh5q",
  spreadLayout: "odules__Compute__styles_ts-spreadLayout-s1h62hgs",
  detailsSection: "odules__Compute__styles_ts-detailsSection-dp7h81m",
  overviewLink: "odules__Compute__styles_ts-overviewLink-o1ibh43u",
  capacityType: "odules__Compute__styles_ts-capacityType-cadi5cf",
  clusterDetailsText: "odules__Compute__styles_ts-clusterDetailsText-c1m2qmnq",
  divider: "odules__Compute__styles_ts-divider-d1l307x1"
};

// Shared styles for hardware templates
export const computeHardwareTemplateStyles = {
  layout: "odules__Compute__styles_ts-layout-l10lsk87",
  instanceItem: "odules__Compute__styles_ts-instanceItem-ijb70tx",
  templateContent: "odules__Compute__styles_ts-templateContent-tg56fhd",
  memory: "odules__Compute__styles_ts-memory-m1gvhh5h",
  configDetails: "odules__Compute__styles_ts-configDetails-cyjjl25",
  configDetailsTitle: "odules__Compute__styles_ts-configDetailsTitle-c19xltif",
  configDetailsLink: "odules__Compute__styles_ts-configDetailsLink-cr57uhb"
};

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");